"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withAccordionSublist = void 0;

var lodash_1 = require("lodash");

var react_1 = __importDefault(require("react"));

var fclasses_1 = require("@bodiless/fclasses");

var components_1 = require("@bodiless/components");

var AccordionWrapper_1 = __importDefault(require("./AccordionWrapper"));

var AccordionBody_1 = require("./AccordionBody");

var AccordionTitle_1 = require("./AccordionTitle");
/**
 * Takes a sublist component and returns a HOC which, when applied to a list item,
 * adds a toggled version of the sublist as an Accordion body to the list item.
 *
 * @param Sublist The sublist component to add to the list accordion body.
 */


var asAccordionSublist = function asAccordionSublist(Sublist) {
  return function (Item) {
    var AccordionWrapper = AccordionWrapper_1.default(Item);
    var AccordionBody = AccordionBody_1.asAccordionBody(Sublist);
    var AccordionTitle = lodash_1.flow(AccordionTitle_1.asAccodionTitle, fclasses_1.asComponent)('div');

    var ItemWithSublist = function ItemWithSublist(_a) {
      var children = _a.children,
          rest = __rest(_a, ["children"]);

      return react_1.default.createElement(AccordionWrapper, null, react_1.default.createElement(AccordionTitle, null, children), react_1.default.createElement(AccordionBody, __assign({}, rest)));
    };

    var ItemWithoutSublist = function ItemWithoutSublist(_a) {
      var wrap = _a.wrap,
          nodeKey = _a.nodeKey,
          rest = __rest(_a, ["wrap", "nodeKey"]);

      return react_1.default.createElement(Item, __assign({}, rest));
    };

    return components_1.withToggleTo(ItemWithoutSublist)(ItemWithSublist);
  };
};

var withAccordionSublist = lodash_1.flow(components_1.withDeleteSublistOnUnwrap, asAccordionSublist, components_1.withSublist);
exports.withAccordionSublist = withAccordionSublist;
exports.default = asAccordionSublist;